import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import TextButton from '@/components/elements/Button/TextButton';
import HighlightValue from '@/components/layouts/Race/RaceCard/Partials/HighlightValue';
import { Value } from '@/components/layouts/Race/RaceCard/Partials/HighlightValue/style';
import { EntryRacer, EntryRacerNote } from '@/lib/apollo/types/gen/graphql';
import { RaceInfoType } from '@/modelTypes';
import {
  fromScreenStorage,
  fromScreenUrlStorage,
} from '@/storages/entryRacer/formData';
import { toHalfWidth } from '@/utility/utils';

import RacerNote from '../Partials/RacerNote';
import {
  Container,
  PrefectureValue,
  RacerInfoDetail,
  RacerName,
} from './style';

interface RaceNameDataProps {
  entryRacer: EntryRacer;
  raceInfoType: RaceInfoType;
  averageRaceScoreNumArray: number[];
  entryRacerNoteList?: EntryRacerNote[];
  showEntryRacerNoteModal?: (entryRacer: EntryRacer) => void;
}

const RacerNameData: React.FC<RaceNameDataProps> = ({
  entryRacer,
  raceInfoType,
  averageRaceScoreNumArray,
  entryRacerNoteList,
  showEntryRacerNoteModal,
}) => {
  const pathname = useLocation().pathname;
  const navigate = useNavigate();
  const clickRacerName = (argRegNum: number) => {
    fromScreenStorage.set('race');
    fromScreenUrlStorage.set(pathname);
    navigate(`/racer/detail?registrationNum=${argRegNum}`);
  };

  return (
    <Container isBorderRightNone={raceInfoType === RaceInfoType.None}>
      <TextButton
        size="s"
        onClick={() => {
          clickRacerName(entryRacer.registrationNum);
        }}
      >
        <RacerName>{entryRacer.name}</RacerName>
      </TextButton>

      {raceInfoType !== RaceInfoType.Score && (
        <>
          <span>({entryRacer.age})</span>
          <RacerNote
            entryRacer={entryRacer}
            entryRacerNoteList={entryRacerNoteList}
            showEntryRacerNoteModal={showEntryRacerNoteModal}
          />
          <RacerInfoDetail>
            <PrefectureValue>{entryRacer.prefecture}</PrefectureValue>/
            <Value>{entryRacer.graduated}期</Value>/
            <Value>
              {toHalfWidth(`${entryRacer.gradeName}${entryRacer.unitName}`)}
            </Value>
            /
            <HighlightValue
              numArray={averageRaceScoreNumArray}
              fractionDigits={2}
              raceInfoType={raceInfoType}
            >
              {entryRacer.entryRacerScore.averageRaceScore}
            </HighlightValue>
          </RacerInfoDetail>
        </>
      )}
    </Container>
  );
};

export default RacerNameData;
